import { render, staticRenderFns } from "./AutoSuggestDropdown.vue?vue&type=template&id=4dc08c96&scoped=true"
import script from "./AutoSuggestDropdown.vue?vue&type=script&lang=js"
export * from "./AutoSuggestDropdown.vue?vue&type=script&lang=js"
import style0 from "./AutoSuggestDropdown.vue?vue&type=style&index=0&id=4dc08c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc08c96",
  null
  
)

export default component.exports